import { PaginationOptions } from './pagination-options';

export class Pagination<T = any> {
  constructor(
    public readonly items: T[],
    public readonly itemCount: number,
    public readonly totalItems: number,
    public readonly pageCount: number,
    public readonly options: PaginationOptions,
    public readonly ids?: number[],
  ) {}

  public static empty<T>(options: PaginationOptions = new PaginationOptions(1, 25)): Pagination<T> {
    return new Pagination([], 0, 0, 1, options);
  }

  public static fromJson<T>(json: any): Pagination<T> {
    return new Pagination<T>(json.items, json.itemCount, json.totalItems, json.pageCount, PaginationOptions.fromJson(json.options), json.ids);
  }
}
